<template>
    <div>
      <v-card class="ma-2">
        <v-card-title><T>Фильтры</T></v-card-title>
        <v-card-text>
          <div style="width: 100%;" class="d-flex">
            <DateFilter :minusDaysForStartDate="7" ref="dateFilter" />
            <v-btn class="mx-2" fab dark color="success" @click="updateData">
              <v-icon dark>mdi-autorenew</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
  
      <v-card class="ma-2">
        <v-card-title><T>Отчет по деньгам</T></v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="formattedTableData"
            :loading="tableLoad"
            :loading-text="$t('Данные загружаются...')"
            :no-data-text="$t('Данные не найдены')"
            hide-default-footer
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import DateFilter from '../../components/orders/DateFilter.vue';

  export default {
    name: 'cashReport',
  
    components: {
      DateFilter
    },
  
    computed: {
      formattedTableData() {
        return this.tableData.map(item => ({
          ...item,
          date: item.date === 'ИТОГО' ? this.$t('ИТОГО') : this.formatDate(item.date)
        }));
      },
      headers() {
        return [
          { text: this.$t('Дата'), align: 'start', value: 'date' },
          { text: this.$t('Наличные'), align: 'center', value: 'cash' },
          { text: this.$t('Карта'), align: 'center', value: 'card' },
          { text: this.$t('Онлайн оплата'), align: 'center', value: 'online' },
          { text: this.$t('ИТОГО за дату'), align: 'center', value: 'total' }
        ];
      }
    },
  
    data() {
      return {
        tableData: [],
        tableLoad: false,
        dateBegin: null,
        dateEnd: null,
      };
    },
  
    async mounted() {
      this.resetTable();
    },
  
    methods: {
      async resetTable() {
        this.dateBegin = this.$refs.dateFilter.getDateBegin();
        this.dateEnd = this.$refs.dateFilter.getDateEnd();
        this.tableLoad = true;
        this.tableData = await this.$store.dispatch('getCashReportInfo', { 
          date_begin: this.dateBegin, 
          date_end: this.dateEnd 
        });
        this.tableLoad = false;
      },
  
      updateData() {
        this.resetTable();
      },
  
      formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
      }
    }
  };
  </script>
  
  <style scoped>
  </style>